export default {
  methods: {
  //
  }
};
